var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"card",attrs:{"to":'article/' + _vm.slug}},[_c('img',{attrs:{"src":_vm.articleData.thumbnail,"alt":""}}),_vm._v(" "+_vm._s(_vm.articleData.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }